// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"b908d749","686":"b4cf4de1","847":"bcf223ae","851":"bb12b617"}[chunkId] + ".chunk.css";
};